import {ErrorCode} from 'react-dropzone';

export default {
  'notAvailable': 'N/A',
  'actionUpdatePosition': 'Update position',

  'maintenanceRegisteredTabTitle': 'Registered',
  'maintenanceUpcomingTabTitle': 'Upcoming',
  'maintenanceOngoingTabTitle': 'Ongoing',
  'maintenanceCompletedTabTitle': 'Completed',

  'maintenanceStatusPending': 'Pending',
  'maintenanceStatusOngoing': 'Ongoing',
  'maintenanceStatusCompleted': 'Completed',
  'maintenanceRealizeFormTitle': 'Linked Maintenance',

  'sharedSelectADate': 'Select a date',
  'sharedTypeHere': 'Type here...',
  'sharedEvery': 'Every',
  'sharedHours': 'Hours',
  'sharedMonths': 'Months',
  'sharedDay': 'Day',
  'sharedCost': 'Cost',
  'sharedCurrent': 'Current',
  'sharedNextF': 'Upcoming',
  'sharedLatest': 'Latest',
  'sharedVehicle': 'Vehicle',
  'sharedOdometer': 'Odometer',
  'sharedDate': 'Date',
  'sharedHourmeter': 'Hourmeter',
  'sharedInterval': 'Interval',
  'sharedTitle': 'Title',
  'sharedKind': 'Kind',
  'sharedPeriod': 'Period',
  'sharedAction': 'Action',
  'sharedCreatedBy': 'Created by',
  'sharedCreatorEmail': 'Creator Email',
  'sharedCreatedAt': 'Created At',
  'sharedUpdatedAt': 'Last Edited',
  'URL': 'URL',

  'sharedCreateNew': 'Create New',
  'sharedIdentification': 'Identification',
  'sharedLoading': 'Loading...',
  'sharedHide': 'Hide',
  'sharedSave': 'Save',
  'sharedSet': 'Set',
  'sharedCancel': 'Cancel',
  'sharedSelect': 'Select',
  'sharedUntil': 'to',
  'sharedNoResultFound': 'No results found!',
  'sharedResults': 'Results',
  'sharedBack': 'Back',
  'deviceAccessDenied': 'This device does not belong to your account.',
  'deviceAccessDeniedBackToDashboard': 'Back to Dashboard',
  'sharedAdd': 'Add',
  'sharedEdit': 'Edit',
  'sharedRemove': 'Remove',
  'sharedConfirm': 'Confirm',
  'sharedConfirmQuestion': 'Confirm?',
  'sharedUpdate': 'Update',
  'sharedConnect': 'Connect',
  'sharedRegister': 'Register',
  'sharedOf': 'of',
  'sharedLogout': 'Logout',
  'sharedYes': 'Yes',
  'sharedNo': 'No',
  'sharedLogin': 'Login',
  'sharedComment': 'Comment',
  'sharedNext': 'Next',
  'sharedPrev': 'Prev',
  'sharedAll': 'All',
  'sharedFirst': 'First',
  'sharedLast': 'Last',
  'sharedNoDataText': 'There is no data to display',
  'sharedEditAttributeFrom': 'Editing Attribute From {name}',
  'sharedCreateAttributeFrom': 'Creating Attribute At {name}',
  'sharedRemoveMessage': 'You are removing',
  'sharedRemoveConfirmationMessage': 'Are you sure you want to do this?',
  'sharedRemoveConfirm': 'Remove item?',
  'sharedKm': 'km',
  'sharedMi': 'mi',
  'sharedNmi': 'nmi',
  'sharedKn': 'kn',
  'sharedKmh': 'km/h',
  'sharedMph': 'mph',
  'sharedHour': 'Hour',
  'sharedMinute': 'Minute',
  'sharedSecond': 'Second',
  'sharedDays': 'days',
  'sharedHours': 'hours',
  'sharedMinutes': 'minutes',
  'sharedDecimalDegrees': 'Decimal Degrees',
  'sharedDegreesDecimalMinutes': 'Degrees Decimal Minutes',
  'sharedDegreesMinutesSeconds': 'Degrees Minutes Seconds',
  'sharedIdentification': 'Identification',
  'sharedTracker': 'Tracker',
  'sharedName': 'Name',
  'sharedDescription': 'Description',
  'sharedSearch': 'Search',
  'searchMinLength': 'Type at least {min} characters to search',
  'searchInputHint': 'Search (min. {min})',
  'sharedSelectAColor': 'Select a color',
  'sharedFilters': 'Filters',
  'sharedGeofence': 'Geofence',
  'sharedGeofences': 'Geofences',
  'fleetSearchPlaceholder': 'Search to filter',
  'fleetFilterBy': 'Filter by:',
  'geofenceAllDevices': 'All Devices',
  'geofenceColor': 'Color',
  'geofenceLineDistance': 'Line Distance (m)',
  'geofenceSpeedLimit': 'Speed Limit (km/h)',
  'sharedSinister': 'Incident',
  'sharedSinisters': 'Incidents',
  'sharedCompany': 'Company',
  'sharedMyCompany': 'My Company',
  'sharedCompanies': 'Companies',
  'sharedCompanyConfiguration': 'Company Configuration',
  'sinisterOpen': 'Open Incident',
  'sinisterCreate': 'Create Incident',
  'sinisterNumber': 'Number',

  'sinisterRobbery': 'Robbery',
  'sinisterTheft': 'Theft',
  'sinisterMisappropriation': 'Misappropriation',
  'sinisterAccident': 'Accident',
  'sinisterOther': 'Other',

  'sinisterTypeAttemptToTriggerPromptResponse': 'Attempt To Trigger Prompt Response',
  'sinisterTypeLimitExceededInSearchConditions': 'Limit Exceeded In Search Conditions',
  'sinisterTypePoliceArriveAtTheScene': 'Police Arrive At TheScene',
  'sinisterTypePromptResponseActivated': 'Prompt Response Activated',
  'sinisterTypeRegisterThePoliceReport': 'Register The Police Report',
  'sinisterTypeRequestedVehicleForVehicleRecovery': 'Requested Vehicle For Vehicle Recovery',
  'sinisterTypeSupportArrivesOnSite': 'Support Arrives On Site',
  'sinisterTypeSupportDoesOnSitePreservation': 'Support Does On Site Preservation',
  'sinisterTypeSupportOnTheWay': 'Support On TheWay',
  'sinisterTypeSupportStartsPatrolling': 'Support Starts Patrolling',
  'sinisterTypeUninstalledEquipmentFound': 'Uninstalled Equipment Found',
  'sinisterTypeUndefined': 'ERROR!',

  'sinisterClosingDate': 'Closing Date',
  'sinisterClosingType': 'Closing Type',
  'sinisterVehicleDamaged': 'Vehicle Damaged',
  'sinisterClosingAddress': 'Closing Address',
  'sinisterClosingDescription': 'Closing Description',
  'sinisterDevicePlate': 'Plate',
  'sinisterDeviceModel': 'Model',
  'sinisterSummary': 'Incident Summary',
  'sinisterDeviceColor': 'Color',
  'sinisterMobile': 'Mobile',
  'sinisterTypeLabel': 'Incident Type',
  'sinisterClosingTitle': 'Closing',
  'sinisterCloseAction': 'Close Incident',
  'sinisterCloseError': 'Error trying to close the incident',
  'sinisterTypeQuestion': 'What type of incident is this',
  'deviceShareError': 'Oops! There was an error sharing the device.',
  'sinisterOpeningDate': 'Opening Date',
  'sinisterStatus': 'Status',
  'sinisterActions': 'Actions',
  'sinisterStatusOpened': 'Opened',
  'sinisterStatusClosedWin': 'Closed',
  'sinisterStatusClosedLost': 'Closed',
  'sinisterTypeVehicleNotFound': 'Vehicle Not Found',
  'sinisterTypeVehicleFound': 'Vehicle Found',
  'sinisterTypeFalsePositive': 'False Positive',
  'sinisterTypeRobbery': 'Robbery',
  'sinisterTypeTheft': 'Theft',
  'sinisterTypeMisappropriation': 'Misappropriation',
  'sinisterTypeAccident': 'Accident',
  'sinisterTypePositionTracking': 'Position Tracking',
  'sinisterTypePositionUpdate': 'Position Update',
  'sinisterTypeOther': 'Other',
  'sinisterOccurrenceDate': 'Occurrence Date',
  'sinisterOccurrenceShowMore': 'Show More',
  'sinisterPositionFieldsUnlocked': 'Latitude and Longitude field are open to edit',
  'sinisterPositionFieldsLocked': 'Latitude and Longitude field are closed to edit',
  'sharedKeyword': 'keyword',
  'sharedNotifications': 'Notifications',
  'sharedNotification': 'Notification',
  'sharedAttributes': 'Attributes',
  'sharedAttribute': 'Attribute',
  'sharedDrivers': 'Drivers',
  'sharedDriver': 'Driver',
  'sharedArea': 'Area',
  'sharedSound': 'Notification Sound',
  'sharedType': 'Type',
  'sharedDistance': 'Distance',
  'sharedHourAbbreviation': 'h',
  'sharedMinuteAbbreviation': 'm',
  'sharedSecondAbbreviation': 's',
  'sharedVoltAbbreviation': 'V',
  'sharedLiterAbbreviation': 'l',
  'sharedGallonAbbreviation': 'gal',
  'sharedLiter': 'Liter',
  'sharedImpGallon': 'Imp. Gallon',
  'sharedUsGallon': 'U.S. Gallon',
  'sharedLiterPerHourAbbreviation': 'l/h',
  'sharedLabel': 'Label',
  'sharedGetMapState': 'Get Map State',
  'sharedComputedAttribute': 'Computed Attribute',
  'sharedComputedAttributes': 'Computed Attributes',
  'sharedCheckComputedAttribute': 'Check Computed Attribute',
  'sharedExpression': 'Expression',
  'sharedDevice': 'Device',
  'sharedTestNotification': 'Send Test Notification',
  'sharedCalendar': 'Calendar',
  'sharedCalendars': 'Calendars',
  'sharedFile': 'File',
  'sharedSelectFile': 'Select File',
  'sharedPhone': 'Phone',
  'sharedRequired': 'Required',
  'sharedPreferences': 'Preferences',
  'sharedPermissions': 'Permissions',
  'sharedExtra': 'Extra',
  'sharedTypeString': 'String',
  'sharedTypeNumber': 'Number',
  'sharedTypeBoolean': 'Boolean',
  'sharedTimezone': 'Timezone',
  'sharedInfoTitle': 'Info',
  'sharedSavedCommand': 'Saved Command',
  'sharedSavedCommands': 'Saved Commands',
  'sharedNew': 'New…',
  'sharedShowAddress': 'Show Address',
  'sharedDisabled': 'Disabled',
  'sharedRealize': 'Realize',
  'sharedMaintenance': 'Maintenance',
  'sharedMaintenances': 'Maintenances',
  'maintenanceCreatedSuccess': 'Maintenance registered successfully!',
  'maintenanceEditedSuccess': 'Maintenance updated successfully!',
  'maintenanceRemovedSuccess': 'Maintenance removed successfully!',
  'maintenanceRealizedSuccess': 'Maintenance carried out successfully!',
  'maintenanceFinishedSuccess': 'Maintenance completed successfully!',
  'maintenanceRemoveTitle': 'Remove Maintenance',
  'maintenanceRemoveDescription': 'Are you sure you want to remove this maintenance? This action cannot be undone.',
  'sharedIntegration': 'Integration',
  'sharedFinancial': 'Financial',
  'sharedValue': 'Value',
  'sharedClear': 'Clear',
  'integrationRemoveConfirm': 'You are removing the integration <strong><field>title</field></strong>! </br>Are you sure you want to do this?',
  'integrationConfigRemoveConfirm': 'You are removing the integration config <strong><field>description</field></strong>! </br>Are you sure you want to do this?',
  'sharedIntegrations': 'Integrations',
  'sharedIntegrationConfig': 'Integration Settings',
  'sharedIntegrationConfigs': 'Integration Settings',
  'billingProvider': 'Provider',
  'billingTargetCustomer': 'End customer',
  'billingPaid': 'Paid',
  'billingOverdue': 'Overdue',
  'billingRecurring': 'Recurring',
  'billingOneOff': 'One-off',
  'billingCharges': 'Charges',
  'billingSubscriptions': 'Subscriptions',
  'billingBillingType': 'Billing type',
  'billingDueDate': 'Due date',
  'billingPaymentDate': 'Payment date',
  'billingNextDueDate': 'Next due date',
  'billingRecurrenceType': 'Recurrence',
  'billingCycle': 'Cycle',
  'billingActiveSubscriptions': 'Active subscriptions',
  'billingNewCharge': 'New charge',
  'billingNewSubscription': 'New subscription',
  'billingCreateCharge': 'Issue charge',
  'billingCreateSubscription': 'Create subscription',
  'billingChargeCreatedSuccess': 'Charge created successfully!',
  'billingSubscriptionCreatedSuccess': 'Subscription created successfully!',
  'billingSubscriptionCancelledSuccess': 'Subscription cancelled successfully!',
  'billingChargeSyncSuccess': 'Charge synced successfully!',
  'billingSubscriptionSyncSuccess': 'Subscription synced successfully!',
  'billingExternalReference': 'External reference',
  'billingEndDate': 'End date',
  'billingMaxPayments': 'Maximum payments',
  'billingSyncCharge': 'Sync charge',
  'billingSyncSubscription': 'Sync subscription',
  'billingReuseCharge': 'Use as draft',
  'billingPaymentDetails': 'Payment',
  'billingPaymentDetailsTitle': 'Payment details',
  'billingCopyPaymentLink': 'Copy link',
  'billingPaymentLinkCopied': 'Payment link copied.',
  'billingPixCodeCopied': 'PIX code copied.',
  'billingOpenBankSlip': 'Open bank slip',
  'billingPixQrCode': 'PIX QR code',
  'billingPixCopyPaste': 'PIX copy and paste',
  'billingPaymentLink': 'Payment link',
  'billingExternalChargeId': 'External charge ID',
  'billingPaymentInstructionsPix': 'Send the QR code or the PIX copy-and-paste code to the customer.',
  'billingPaymentInstructionsBoleto': 'Open the bank slip to view, print, or share it with the customer.',
  'billingPaymentInstructionsDefault': 'Open the charge or copy the payment link to share it with the customer.',
  'billingPaymentDetailsUnavailable': 'Unable to load payment details.',
  'billingNoPaymentLink': 'This charge does not have a payment link yet.',
  'billingNoPixQrCode': 'The provider has not returned a PIX QR code for this charge yet.',
  'billingSendByWhatsapp': 'WhatsApp',
  'billingSendByEmail': 'Email',
  'billingCustomerPhoneUnavailable': 'The end customer does not have a phone number registered.',
  'billingCustomerEmailUnavailable': 'The end customer does not have an email registered.',
  'billingOpenInvoice': 'Open invoice',
  'billingCancelSubscription': 'Cancel subscription',
  'billingSummaryTotalCharges': 'Total charges',
  'billingSummaryPaidCharges': 'Paid charges',
  'billingSummaryUnpaidCharges': 'Open charges',
  'billingSummaryOverdueCharges': 'Overdue charges',
  'billingSummaryRecurringCharges': 'Recurring charges',
  'billingSummaryActiveSubscriptions': 'Active subscriptions',
  'billingSummarySuspendedCustomers': 'Suspended customers',
  'billingSummaryChargeCount': '{count, plural, one {# charge} other {# charges}}',
  'billingSummarySubscriptionCount': '{count, plural, one {# subscription} other {# subscriptions}}',
  'billingChargeStatusPending': 'Pending',
  'billingChargeStatusReceived': 'Received',
  'billingChargeStatusConfirmed': 'Confirmed',
  'billingChargeStatusReceivedInCash': 'Received in cash',
  'billingChargeStatusOverdue': 'Overdue',
  'billingSubscriptionStatusActive': 'Active',
  'billingSubscriptionStatusInactive': 'Inactive',
  'billingSubscriptionStatusCancelled': 'Cancelled',
  'billingSubscriptionStatusExpired': 'Expired',
  'billingSubscriptionStatusDeleted': 'Deleted',
  'billingChargeStatusRefunded': 'Refunded',
  'billingChargeStatusDeleted': 'Deleted',
  'billingChargeStatusRefundRequested': 'Refund requested',
  'billingChargeStatusRefundInProgress': 'Refund in progress',
  'billingChargeStatusChargebackRequested': 'Chargeback requested',
  'billingChargeStatusChargebackDispute': 'Chargeback dispute',
  'billingChargeStatusAwaitingChargebackReversal': 'Awaiting chargeback reversal',
  'billingChargeStatusDunningRequested': 'Dunning requested',
  'billingChargeStatusDunningReceived': 'Received (dunning)',
  'billingChargeStatusAwaitingRiskAnalysis': 'Awaiting risk analysis',
  'billingProviderNotConfigured': 'There is no active Asaas integration for this central. Configure the integration to issue charges and subscriptions.',
  'billingProviderMissingToken': 'This central\'s Asaas integration has no API key. Enter the key in the integration settings to issue charges and subscriptions.',
  'billingProviderMultipleConfigs': 'This central has more than one active Asaas integration. Keep only one active in the integration settings to issue charges and subscriptions.',
  'billingConfigureIntegration': 'Configure integration',
  'billingCancelSubscriptionConfirm': 'Cancel permanently',
  'billingCancelSubscriptionConfirmDescription': 'Cancellation is permanent in Asaas: the recurrence ends and this subscription\'s pending and overdue charges are removed. Continue?',
  'billingCycleWeekly': 'Weekly',
  'billingCycleBiweekly': 'Biweekly',
  'billingCycleMonthly': 'Monthly',
  'billingCycleBimonthly': 'Bimonthly',
  'billingCycleQuarterly': 'Quarterly',
  'billingCycleSemiannually': 'Semiannually',
  'billingCycleYearly': 'Yearly',
  'sharedDeviceAccumulators': 'Accumulators',
  'sharedAlarms': 'Alarms',
  'mapStreets': 'Streets',
  'sharedClose': 'Close',
  'sharedColor': 'Color',
  'sharedSavedSuccess': 'Your data has been saved',
  'sharedRemovedSuccess': 'Your data has been removed',
  'sharedUpdatedSuccess': 'Your data has been updated',
  'permissionsUpdatedSuccess': 'Permissions updated successfully!',
  'sharedUrlInvalid': 'Enter a valid URL',
  'sharedError': 'Ops! Internal Error',
  'sharedBadRequest': 'Unauthorized Operation',
  'sharedForbidden': 'Has no access rights',
  'sharedUnauthorized': 'Unauthenticated user',
  'sharedNotFound': 'Not Found',
  'sharedActivated': 'Activated',
  'sharedNotActivated': 'Not Activated',
  'sharedDate': 'Date',
  'sharedUserPaymentDetail': 'Payment Data',
  'sharedUser': 'User',
  'sharedCustomers': 'Customers',
  'sharedCustomer': 'Customer',
  'deviceOwnerCustomer': 'Owner',
  'sharedAddress': 'Address',
  'sharedNoResultsFound': 'No results found!',
  'sharedChooseADevice': 'Choose a device',
  'attributeSpeedLimit': 'Speed Limit',
  'attributePolylineDistance': 'Polyline Distance',
  'attributeReportIgnoreOdometer': 'Ignore device odometer',
  'attributeWebReportColor': 'Web: Report Color',
  'attributeDevicePassword': 'Device Password',
  'attributeProcessingCopyAttributes': 'Processing: Copy Attributes',
  'attributeColor': 'Color',
  'attributeWebLiveRouteLength': 'Web: Live Route Length',
  'attributeWebSelectZoom': 'Web: Zoom On Select',
  'attributeWebMaxZoom': 'Web: Maximum Zoom',
  'attributeMailSmtpHost': 'Mail: SMTP Host',
  'attributeMailSmtpPort': 'Mail: SMTP Port',
  'attributeMailSmtpStarttlsEnable': 'Mail: SMTP STARTTLS Enable',
  'attributeMailSmtpStarttlsRequired': 'Mail: SMTP STARTTLS Required',
  'attributeMailSmtpSslEnable': 'Mail: SMTP SSL Enable',
  'attributeMailSmtpSslTrust': 'Mail: SMTP SSL Trust',
  'attributeMailSmtpSslProtocols': 'Mail: SMTP SSL Protocols',
  'attributeMailSmtpFrom': 'Mail: SMTP From',
  'attributeMailSmtpAuth': 'Mail: SMTP Auth Enable',
  'attributeMailSmtpUsername': 'Mail: SMTP Username',
  'attributeMailSmtpPassword': 'Mail: SMTP Password',
  'attributeUiDisableReport': 'UI: Disable Report',
  'attributeUiDisableEvents': 'UI: Disable Events',
  'attributeUiDisableVehicleFetures': 'UI: Disable Vehicle Fetures',
  'attributeUiDisableDrivers': 'UI: Disable Drivers',
  'attributeUiDisableComputedAttributes': 'UI: Disable Computed Attributes',
  'attributeUiDisableCalendars': 'UI: Disable Calendars',
  'attributeUiDisableMaintenances': 'UI: Disable Maintenances',
  'attributeUiHidePositionAttributes': 'UI: Hide Position Attributes',
  'errorAuthorization': 'Invalid credential authorization, please check email and password.',
  'errorTitle': 'Error',
  'errorGeneral': 'Invalid parameters or constraints violation',
  'errorConnection': 'Connection error',
  'errorSocket': 'Web socket connection error',
  'errorZero': 'Can\'t be zero',
  'userEmail': 'Email',
  'userPassword': 'Password',
  'userAdmin': 'Admin',
  'userRemember': 'Remember',
  'userExpirationTime': 'Expiration',
  'userDeviceLimit': 'Device Limit',
  'userUserLimit': 'User Limit',
  'userDeviceReadonly': 'Default',
  'userLimitCommands': 'No Commands Sent',
  'userToken': 'Token',
  'userKeyword': 'Keyword',
  'loginTitle': 'Login',
  'loginLanguage': 'Language',
  'loginRegister': 'Register',
  'loginLogin': 'Login',
  'loginFailed': 'Incorrect email address or password',
  'loginCreated': 'New user has been registered',
  'loginLogout': 'Logout',
  'loginLogo': 'Logo',
  'devicePositionUpdateSuccess': 'Device position updated successfully!',
  'devicesAndState': 'Devices and State',
  'deviceTitle': 'Devices',
  'deviceIdentifier': 'Identifier',
  'deviceImei': 'IMEI',
  'deviceModel': 'Model',
  'deviceContact': 'Contact',
  'deviceCategory': 'Category',
  'deviceLastUpdate': 'Last Update',
  'deviceActionsTitle': 'Device Actions',
  'deviceInfoTitle': 'Device Information',
  'deviceNotIdentified': 'Not identified',
  'deviceModalTitle': 'Title',
  'mapShareLinkCopied': 'Share link copied to clipboard.',
  'hashNotValidTitle': 'Invalid or expired link!',
  'hashRedirectMessage': 'You will be redirected to the login page shortly.',
  'hashBackToLogin': 'Back to login page.',
  'hashValidatingTitle': 'Loading...',
  'mapSatellite': 'Satellite',
  'deviceDeviceTime': 'Device',
  'deviceServerTime': 'Server',
  'deviceStoppedFor': 'Stopped for',
  'deviceLimit': 'Device Limit',
  'deviceCommand': 'Command',
  'deviceFollow': 'Follow',
  'deviceRoute': 'Route',
  'deviceBlock': 'Block',
  'deviceRelease': 'Release',
  'deviceFence': 'Fence',
  'deviceShare': 'Share',
  'deviceTotalDistance': 'Total Distance',
  'deviceOdometerHourmeter': 'Odometer/Hourmeter',
  'accumulatorUnitKm': 'km',
  'accumulatorUnitMi': 'mi',
  'accumulatorUnitNmi': 'nmi',
  'accumulatorCurrentOdometer': 'Current odometer ({unit})',
  'accumulatorCurrentHourmeter': 'Current hourmeter (hours)',
  'accumulatorStoppedNotice': 'Editing is only possible while the vehicle is stopped. While it is moving, try again after it has stopped.',
  'accumulatorEditHint': 'Click to edit odometer and hour meter',
  'accumulatorPlatformOdometerEnabled': 'The platform odometer is now on for this vehicle: its reports use it instead of the device odometer.',
  'accumulatorPlatformOdometerNotice': 'When you save, this vehicle\'s reports will use the platform odometer instead of the device odometer.',
  'accumulatorRangeError': 'Enter a value between 0 and {max}.',
  'accumulatorDecimalError': 'Use at most one decimal place.',
  'accumulatorRolledOver': 'The counter reached its maximum and restarted at 0. It can no longer be edited.',
  'accumulatorNoPosition': 'This device has not reported a position yet. The odometer and the hourmeter can only be edited after the first position.',
  'accumulatorNothingChanged': 'No value was changed.',
  'accumulatorNeverEdited': 'Never edited',
  'accumulatorFieldOdometer': 'Odometer',
  'accumulatorFieldHourmeter': 'Hourmeter',
  'accumulatorLowerBlocked': 'This field was already edited: you can only enter {min} or more.',
  'accumulatorColRegistered': 'Registration date',
  'accumulatorColField': 'Field',
  'accumulatorColPrevious': 'Last recorded value',
  'accumulatorColEditedAt': 'Edit date',
  'accumulatorColNew': 'Edited value',
  'accumulatorColUser': 'Edited by',
  'accumulatorColEmail': 'User e-mail',
  'accumulatorHistoryError': 'Could not load the odometer and hourmeter edits.',
  'deviceTrail': 'Trail',
  'deviceStatus': 'Status',
  'deviceStatusOnline': 'Online',
  'deviceStatusOffline': 'Offline',
  'deviceStatusUnknown': 'Unknown',

  'deviceM2mProvider': 'M2M Provider',
  'deviceIccid': 'ICCID',
  'devicePlate': 'Plate',
  'deviceYear': 'Year',
  'deviceVehicleModel': 'Vehicle Model',
  'deviceFipeSearchPlaceholder': 'Type brand or model…',
  'deviceFipeSearchEmpty': 'No vehicle found',
  'deviceFipeSearchError': 'Failed to search FIPE',
  'deviceFipeResolveError': 'Failed to load vehicle data',
  'deviceFuelType': 'Fuel Type',
  'deviceFuelConsumption': 'Fuel Consumption',
  'deviceManufacturer': 'Manufacturer',
  'deviceColor': 'Color',
  'deviceRenavam': 'Renavam',
  'deviceChassi': 'Chassi',
  'deviceInstallationLocation': 'Installation Location',
  'deviceTechnician': 'Technician',
  'devicePassword': 'Password',
  'deviceSpeedLimit': 'Speed Limit',
  'deviceIgnoreOdometerOff': 'Device odometer (default GPS)',
  'deviceIgnoreOdometerOn': 'Platform odometer',
  'deviceIsShareable': 'PRF mirroring',
  'deviceIsMirrorable': 'Herrlog mirroring',
  'deviceSelectedNeverPositioned': 'The selected device never positioned.',

  'deviceImage': 'Image',
  'deviceImagesDndTitle': 'Drag and drop images here',
  'deviceImagesDndSupportedExtensions': 'JPEG and PNG up to 1 MB.',
  'deviceImagesSelectFile': 'Pick File',
  'deviceImagesSelectFileHelper': '*4 uploads maximum',
  'deviceImagePinAction': 'Highlight Image',
  'deviceImageRemoveAction': 'Delete',
  'deviceImagesUnlockEdition': 'Unlock edition',
  'deviceImagesUnlockDialogTitle': 'Attention',
  'deviceImagesUnlockDialogContent': 'If you choose to unlock editing, then you will lose the images you already have.',
  'deviceImagesUnlockDialogConfirm': 'Unlock',
  'deviceImagesUnlockDialogCancel': 'Cancel',
  'deviceVehicleImage': 'Vehicle Image',
  'deviceVehicleImageEmpty': 'There are no images.',
  'deviceMoreInfo': 'More Info',
  'deviceNoMoreInfo': 'No more info.',
  'geofenceCreateSuccess': 'Geofence created with success',
  'geofenceCreateFail': 'Unable to process your request!',
  'geofenceCreateFailed': 'Unable to process your request!',

  'groupDialog': 'Group',
  'groupParent': 'Group',
  'groupNoGroup': 'No Group',
  'settingsTitle': 'Settings',
  'settingsUser': 'Account',
  'settingsGroups': 'Groups',
  'settingsServer': 'Server',
  'settingsUsers': 'Users',
  'settingsDistanceUnit': 'Distance Unit',
  'settingsSpeedUnit': 'Speed Unit',
  'settingsVolumeUnit': 'Volume Unit',
  'settingsTwelveHourFormat': '12-hour Format AM/PM',
  'settingsCoordinateFormat': 'Coordinates Format',
  'reportTitle': 'Reports',
  'reportDevice': 'Device',
  'reportGroup': 'Group',
  'reportFrom': 'From',
  'reportTo': 'To',
  'reportShow': 'Show',
  'reportClear': 'Clear',
  'reportDaily': 'Daily',
  'positionFixTime': 'Time',
  'positionValid': 'Valid',
  'positionAccuracy': 'Accuracy',
  'positionLatitude': 'Latitude',
  'positionLongitude': 'Longitude',
  'positionAltitude': 'Altitude',
  'positionSpeed': 'Speed',
  'positionCourse': 'Course',
  'positionAddress': 'Address',
  'positionProtocol': 'Protocol',
  'positionDistance': 'Distance',
  'positionRpm': 'RPM',
  'positionFuel': 'Fuel',
  'positionPower': 'Power',
  'positionBattery': 'Battery',
  'positionBatteryVoltage': 'Battery V.',
  'positionRaw': 'Raw',
  'positionIndex': 'Index',
  'positionHdop': 'HDOP',
  'positionVdop': 'VDOP',
  'positionPdop': 'PDOP',
  'positionSat': 'Satellites',
  'positionSatVisible': 'Visible Satellites',
  'positionRssi': 'RSSI',
  'positionGps': 'GPS',
  'positionRoaming': 'Roaming',
  'positionEvent': 'Event',
  'positionAlarm': 'Alarm',
  'positionStatus': 'Status',
  'positionOdometer': 'Odometer',
  'positionServiceOdometer': 'Service Odometer',
  'positionTripOdometer': 'Trip Odometer',
  'positionHours': 'Hourmeter',
  'positionSteps': 'Steps',
  'positionInput': 'Input',
  'positionOutput': 'Output',
  'positionBatteryLevel': 'Battery Level',
  'positionFuelConsumption': 'Fuel Consumption',
  'positionRfid': 'RFID',
  'positionVersionFw': 'Firmware Version',
  'positionVersionHw': 'Hardware Version',
  'positionIgnition': 'Ignition',
  'positionFlags': 'Flags',
  'positionCharge': 'Charge',
  'positionIp': 'IP',
  'positionArchive': 'Archive',
  'positionVin': 'VIN',
  'positionApproximate': 'Approximate',
  'positionThrottle': 'Throttle',
  'positionMotion': 'Motion',
  'positionArmed': 'Armed',
  'positionAcceleration': 'Acceleration',
  'positionDeviceTemp': 'Device Temperature',
  'positionOperator': 'Operator',
  'positionCommand': 'Command',
  'positionBlocked': 'Blocked',
  'positionDtcs': 'DTCs',
  'positionObdSpeed': 'OBD Speed',
  'positionObdOdometer': 'OBD Odometer',
  'positionDriverUniqueId': 'Driver Unique Id',
  'positionStoppedTime': 'Stopped Time',
  'positionImage': 'Image',
  'positionAudio': 'Audio',
  'positionTotalDistance': 'Total Distance',
  'positionType': 'Type',
  'positionIn': 'In',
  'positionOut': 'Out',
  'serverTitle': 'Server Settings',
  'serverZoom': 'Zoom',
  'serverRegistration': 'Registration',
  'serverReadonly': 'View Only',
  'serverForceSettings': 'Force Settings',
  'mapTitle': 'Map',
  'mapLayer': 'Map Layer',
  'mapCustom': 'Custom Map',
  'mapCarto': 'Carto Basemaps',
  'mapOsm': 'Open Street Map',
  'mapBingKey': 'Bing Maps Key',
  'mapBingRoad': 'Bing Maps Road',
  'mapBingAerial': 'Bing Maps Aerial',
  'mapBingHybrid': 'Bing Maps Hybrid',
  'mapBaidu': 'Baidu',
  'mapYandexMap': 'Yandex Map',
  'mapYandexSat': 'Yandex Satellite',
  'mapWikimedia': 'Wikimedia',
  'mapShapePolygon': 'Polygon',
  'mapShapeCircle': 'Circle',
  'mapShapePolyline': 'Polyline',
  'mapLiveRoutes': 'Live Routes',
  'mapPoiLayer': 'POI Layer',
  'mapKindStreet': 'Street',
  'mapKindSatellite': 'Satellite',
  'mapKindNotAvailable': 'Map not available!',
  'stateTitle': 'State',
  'stateName': 'Attribute',
  'stateValue': 'Value',
  'commandTitle': 'Command',
  'commandSend': 'Send',
  'commandBlockConfirm': 'Are you sure you want to block vehicle {name}?',
  'commandUnblockConfirm': 'Are you sure you want to unblock vehicle {name}?',
  'commandSent': 'Command sent',
  'deviceNoLongerAccessible': 'This device no longer belongs to your account. Refreshing the page...',
  'deviceNoLongerAccessibleShared': 'This device is no longer available on this link. Refreshing the page...',
  'commandQueued': 'Command queued',
  'commandUnit': 'Unit',
  'commandCustom': 'Custom command',
  'commandMotionInterval': 'Motion interval',
  'commandStopInterval': 'Stop Interval',
  'commandResetOdometer': 'Reset Odometer',
  'commandAlarmIdle': 'Idle Alarm',
  'commandAlarmRemove': 'Remove Alarm',
  'commandDeviceIdentification': 'Device Identification',
  'commandPositionSingle': 'Single Reporting',
  'commandPositionPeriodic': 'Periodic Reporting',
  'commandPositionStop': 'Stop Reporting',
  'commandEngineStop': 'Engine Stop',
  'commandEngineResume': 'Engine Resume',
  'commandAlarmArm': 'Arm Alarm',
  'commandAlarmDisarm': 'Disarm Alarm',
  'commandSetTimezone': 'Set Timezone',
  'commandRequestPhoto': 'Request Photo',
  'commandRebootDevice': 'Reboot Device',
  'commandSendSms': 'Send SMS',
  'commandSendUssd': 'Send USSD',
  'commandSosNumber': 'Set SOS Number',
  'commandSilenceTime': 'Set Silence Time',
  'commandSetPhonebook': 'Set Phonebook',
  'commandVoiceMessage': 'Voice Message',
  'commandOutputControl': 'Output Control',
  'commandVoiceMonitoring': 'Voice Monitoring',
  'commandSetAgps': 'Set AGPS',
  'commandSetIndicator': 'Set Indicator',
  'commandConfiguration': 'Configuration',
  'commandGetVersion': 'Get Version',
  'commandFirmwareUpdate': 'Update Firmware',
  'commandSetConnection': 'Set Connection',
  'commandSetOdometer': 'Set Odometer',
  'commandGetModemStatus': 'Get Modem Status',
  'commandGetDeviceStatus': 'Get Device Status',
  'commandModePowerSaving': 'Modify Power Saving',
  'commandModeDeepSleep': 'Modify Deep Sleep',
  'commandMovementAlarm': 'Movement Alarm',
  'commandFrequency': 'Frequency',
  'commandTimezone': 'Timezone Offset',
  'commandMessage': 'Message',
  'commandRadius': 'Radius',
  'commandEnable': 'Enable',
  'commandData': 'Data',
  'commandIndex': 'Index',
  'commandPhone': 'Phone Number',
  'commandServer': 'Server',
  'commandPort': 'Port',
  'eventAll': 'All Events',
  'eventDeviceOnline': 'Status online',
  'eventDeviceUnknown': 'Status unknown',
  'eventDeviceOffline': 'Status offline',
  'eventDeviceMoving': 'Device moving',
  'eventDeviceStopped': 'Device stopped',
  'eventDeviceInactive': 'Device inactive',
  'eventDeviceOverspeed': 'Speed limit exceeded',
  'eventDeviceFuelDrop': 'Fuel drop',
  'eventCommandResult': 'Command result',
  'eventCommandSent': 'Command sent',
  'eventGeofenceEnter': 'Geofence entered',
  'eventGeofenceExit': 'Geofence exited',
  'eventAlarm': 'Alarm',
  'eventIgnitionOn': 'Ignition on',
  'eventIgnitionOff': 'Ignition off',
  'eventMaintenance': 'Maintenance required',
  'eventTextMessage': 'Text message received',
  'eventDriverChanged': 'Driver changed',
  'eventQueuedCommandSent': 'Queued command sent',
  'eventDeviceFuelIncrease': 'Device Fuel Increase',
  'eventMedia': 'Media',
  'eventReportReady': 'Report ready',
  'eventsScrollToLast': 'Scroll To Last',
  'alarmGeneral': 'General',
  'alarmSos': 'SOS',
  'alarmVibration': 'Vibration',
  'alarmMovement': 'Movement',
  'alarmLowspeed': 'Low Speed',
  'alarmOverspeed': 'Overspeed',
  'alarmFallDown': 'Fall Down',
  'alarmLowPower': 'Low Power',
  'alarmLowBattery': 'Low Battery',
  'alarmFault': 'Fault',
  'alarmPowerOff': 'Power Off',
  'alarmPowerOn': 'Power On',
  'alarmDoor': 'Door',
  'alarmLock': 'Lock',
  'alarmUnlock': 'Unlock',
  'alarmGeofence': 'Geofence',
  'alarmGeofenceEnter': 'Geofence Enter',
  'alarmGeofenceExit': 'Geofence Exit',
  'alarmGpsAntennaCut': 'GPS Antenna Cut',
  'alarmAccident': 'Accident',
  'alarmTow': 'Tow',
  'alarmIdle': 'Idle',
  'alarmHighRpm': 'High RPM',
  'alarmHardAcceleration': 'Hard Acceleration',
  'alarmHardBraking': 'Hard Braking',
  'alarmHardCornering': 'Hard Cornering',
  'alarmLaneChange': 'Lane Change',
  'alarmFatigueDriving': 'Fatigue Driving',
  'alarmPowerCut': 'Power Cut',
  'alarmPowerRestored': 'Power Restored',
  'alarmJamming': 'Jamming',
  'alarmTemperature': 'Temperature',
  'alarmParking': 'Parking',
  'alarmShock': 'Shock',
  'alarmBonnet': 'Bonnet',
  'alarmFootBrake': 'Foot Brake',
  'alarmFuelLeak': 'Fuel Leak',
  'alarmTampering': 'Tampering',
  'alarmRemoving': 'Removing',
  'notificationType': 'Type of Notification',
  'notificationAlways': 'All Devices',
  'notificationReportReadyRequiresAlways': 'The report-ready notification can only be created with "All Devices" checked.',
  'notificationNotificators': 'Channels',
  'notificatorWeb': 'Web',
  'notificatorMail': 'Mail',
  'notificatorSms': 'SMS',
  'notificatorFirebase': 'Mobile',
  'reportNew': 'New Report',
  'commandNew': 'New Command',
  'sinisterNew': 'New Incident',
  'sinisterOccurrenceAddedSuccess': 'Occurrence added successfully',
  'sinisterOccurrenceCreateError': 'Error creating occurrence',
  'sinisterClosedSuccess': 'Incident closed successfully',
  'sinisterAddImage': 'Add Image',
  'sinisterTimeField': 'Time*',
  'sinisterEssentialInfo': 'Essential Information',
  'sinisterAddOccurrence': '+ Add Occurrence',
  'sinisterHistory': 'History',
  'sinisterFillEssentialInfo': 'Fill in the essential information to register the new incident!',
  'sinisterOccurrenceLabel': 'Occurrence',
  'sinisterTimeLabel': 'Time:',
  'sinisterOccurrenceText': 'Occurrence:',
  'sinisterEssentialInfoTitle': 'Essential Information',
  'sinisterDownloadReport': 'Download Report',
  'sinisterReportedBy': 'Reported By',
  'sinisterDescription': 'Describe the event that occurred',
  'sinisterInfoLabel': 'Information:',
  'sinisterPdfFileName': 'report.pdf',
  'sinisterOccurrenceTitle': 'Occurrence - {type}',
  'reportMarkersSampled': 'Report with {count} positions: showing one marker every {step}. The route line is complete.',
  'reportRoute': 'Route',
  'reportEvents': 'Events',
  'reportTrips': 'Trips',
  'reportStops': 'Stops',
  'reportSummary': 'Summary',
  'reportChart': 'Chart',
  'reportConfigure': 'Configure',
  'reportEventTypes': 'Event Types',
  'reportChartType': 'Chart Type',
  'reportShowMarkers': 'Show Markers',
  'reportExport': 'Request Spreadsheet',
  'reportExportPdf': 'Request PDF',
  'reportEmail': 'Email Report',
  'reportPeriod': 'Period',
  'reportCustom': 'Custom',
  'reportToday': 'Today',
  'reportYesterday': 'Yesterday',
  'reportThisWeek': 'This Week',
  'reportPreviousWeek': 'Previous Week',
  'reportThisMonth': 'This Month',
  'reportPreviousMonth': 'Previous Month',
  'reportCurrentMonth': 'This Month',
  'reportCustomPeriod': 'Custom',
  'reportChoosePeriod': 'Choose period',
  'reportChooseDevices': 'Choose device(s)',
  'reportChooseGroups': 'Choose group',
  'reportChooseEvents': 'Choose event(s)',
  'reportSendByEmail': 'Request e-mail delivery',
  'reportGoTo': 'Report on Map',
  'reportFileNamePattern': '{report} Report',
  'reportFileNameManyDevices': 'multiple devices',
  'reportFileNameOneDevice': '1 device',
  'reportFileNameDeviceCount': '{count} devices',
  'reportFileNameDays': '{count} days',
  'reportPeriodLimit': 'A report covers at most {days} days. For a longer period, generate one report every {days} days.',
  'reportEmailNotConfigured': 'E-mail sending is not set up. Contact your control center.',
  'reportValid': 'Valid',
  'reportSpeed': 'Speed',
  'reportDateAndTime': 'Date and Time',
  'reportObservation': 'Observation',
  'reportMaintenanceEntry': 'Maintenance: {name}',
  'reportAlarmType': 'Alarm type: {name}',
  'reportGeofenceEntry': 'Geofence: {name}',
  'reportCommandSentBy': 'Command {command} sent by user: {name} - e-mail: {email}',
  'reportCommandSentNoUser': 'Command {command} sent',
  'reportRouteResult': 'Result: {result}',
  'reportEmailSuccess': 'You will receive your report by e-mail',
  'reportEmailError': 'Could not process your request!',
  'reportJobQueued': 'Generating the report. You can close this screen — we will let you know when it is ready.',
  'reportJobQueuedEstimate': 'Generating the report, ready in up to {estimate}. You can close this screen — we will let you know when it is ready.',
  'reportJobAlreadyReady': 'Report already generated. Check whether you already downloaded it.',
  'sharedReportJobs': 'Requested Reports',
  'reportJobsEmpty': 'No report has been requested.',
  'reportJobLinkNotFound': 'Report not found. The link may belong to another account, or the report has expired.',
  'reportJobStatusPending': 'Queued',
  'reportJobStatusRunning': 'Generating',
  'reportJobStatusDone': 'Ready',
  'reportJobStatusFailed': 'Failed',
  'reportJobStatusCancelled': 'Cancelled',
  'reportJobStatusExpired': 'Expired',
  'reportJobDownload': 'Download',
  'reportJobCancel': 'Cancel',
  'reportJobCancelConfirm': 'Cancel this report? If it has not been generated yet, generation is stopped before finishing.',
  'reportJobColumnReport': 'Report',
  'reportJobColumnRequested': 'Requested at',
  'reportJobColumnRequester': 'Requested by',
  'reportJobColumnStatus': 'Status',
  'reportJobColumnEstimate': 'Estimate',
  'reportJobEstimateFinishing': 'finishing…',
  'reportJobEstimateCalculating': 'calculating…',
  'reportJobDurationSeconds': '{count} s',
  'reportJobDurationMinutes': '{count} min',
  'reportJobDurationHours': '{count} h',
  'reportJobDurationDays': '{count, plural, one {# day} other {# days}}',
  'reportJobDurationMonths': '{count, plural, one {# month} other {# months}}',
  'reportJobColumnGenerated': 'Generated at',
  'reportJobDevicesButton': 'Devices',
  'reportJobDevicesModalTitle': 'Report devices',
  'reportJobDevicesEmpty': 'No devices found for this report.',
  'reportJobDevicesImei': 'IMEI',
  'reportJobDevicesTotalDistance': 'Total Distance Traveled',
  'reportLoadError': 'Could not load the report.',
  'reportJobErrorNotReady': 'The report is not ready yet.',
  'reportJobErrorAlreadyFinished': 'This report has already finished and cannot be cancelled.',
  'reportJobErrorUnsupportedType': 'This report type is not available in the queue.',
  'reportJobErrorUnsupportedFormat': 'This report format is not available.',
  'reportJobErrorInvalidPeriod': 'Enter a valid period: the start date must be before the end date.',
  'reportJobErrorNoDevices': 'No devices are available for this report.',
  'reportJobErrorStorageNotConfigured': 'Report generation is not set up. Contact your control center.',
  'reportJobMailTooLarge': 'The report is ready, but it is too large to be sent by e-mail. Download the file in Requested Reports.',
  'reportJobDevicesError': 'Could not load the devices of this report.',
  'reportJobFailureWorkerDied': 'Generation was interrupted before it finished. Request the report again.',
  'reportJobFailureGenerationFailed': 'The report could not be generated. Request it again.',
  'reportJobFailureUnknown': 'Report generation failed.',
  'reportChooseReport': 'Choose a report',
  'reportJourney': 'Journey',
  'reportCertadocFines': 'Fines (Certadoc)',
  'certadocCheckFines': 'Check Fines',
  'certadocFines': 'Fines',
  'certadocNoFines': 'No fines returned for this plate. Check whether the vehicle is registered at Certadoc.',
  'certadocNoPlate': 'Device has no plate registered. Ask your Central to register the plate.',
  'certadocRequestError': 'Could not fetch fines from Certadoc.',
  'certadocColCategory': 'Category',
  'certadocColAit': 'Ticket number',
  'certadocColDate': 'Date',
  'certadocColTime': 'Time',
  'certadocColDescription': 'Violation',
  'certadocColValue': 'Amount (R$)',
  'certadocColSituation': 'Situation',
  'certadocColStatus': 'Status',
  'certadocColAgency': 'Agency',
  'certadocColCode': 'Violation code',
  'certadocColDueDate': 'Due date',
  'certadocColAddress': 'Address',
  'certadocColCity': 'City',
  'certadocColState': 'State',
  'certadocColDocuments': 'Documents',
  'certadocDocumentTicket': 'Payment slip',
  'certadocDocumentSupport': 'Evidence',
  'certadocCategoryPagas': 'Paid',
  'certadocCategoryAPagar': 'Due',
  'certadocCategoryNotificacoes': 'Notices',
  'certadocCategoryMultasNic': 'NIC fines',
  'certadocCategoryOutros': 'Other',
  'reportDeviceName': 'Device Name',
  'reportAverageSpeed': 'Average Speed',
  'reportMaximumSpeed': 'Maximum Speed',
  'reportEngineHours': 'Engine Hours',
  'reportStationaryHours': 'Stopped Hours',
  'reportIdleHours': 'Idle Hours',
  'reportDuration': 'Duration',
  'reportStartTime': 'Start Time',
  'reportStartAddress': 'Start Address',
  'reportEndTime': 'End Time',
  'reportEndAddress': 'End Address',
  'reportSpentFuel': 'Spent Fuel',
  'reportStartOdometer': 'Odometer Start',
  'reportEndOdometer': 'Odometer End',
  'statisticsTitle': 'Statistics',
  'statisticsCaptureTime': 'Capture Time',
  'statisticsActiveUsers': 'Active Users',
  'statisticsActiveDevices': 'Active Devices',
  'statisticsRequests': 'Requests',
  'statisticsMessagesReceived': 'Messages Received',
  'statisticsMessagesStored': 'Messages Stored',
  'statisticsGeocoder': 'Geocoder Requests',
  'statisticsGeolocation': 'Geolocation Requests',

  'maintenanceStart': 'Start',
  'maintenancePeriod': 'Period',

  'customerCpfCnpj': 'Tax ID',
  'customerType': 'Type',
  'customerName': 'Name',
  'customerStreet': 'Street',
  'customerNumber': 'Number',
  'customerComplement': 'Complement',
  'customerNeighborhood': 'Neighborhood',
  'customerCity': 'City',
  'customerState': 'State',
  'customerPostalCode': 'CEP',
  'customerPhone': 'Phone',
  'customerCellphone': 'Cellphone',
  'customerNotificationEmail': 'Primary email',
  'customerSecondaryEmail': 'Secondary Email',
  'customerCategory': 'Category',
  'customerCategoryClient': 'Client',
  'customerCategoryPartner': 'Partner',
  'customerCategoryMonitoring': 'Monitoring',
  'customerStatus': 'Status',
  'customerStatusActive': 'Active',
  'customerStatusFrozen': 'Frozen',
  'customerStatusInactive': 'Inactive',
  'customerStatusTrial': 'Trial',
  'customerContact': 'Contact',
  'customerNotes': 'Notes',
  'customerDisabled': 'Disabled',
  'customerRegistrationDate': 'Registration Date',
  'customerExpirationDate': 'Expiration Date',
  'customerInvoiceDay': 'Invoice Day',
  'customerAttributes': 'Attributes',

  'categoryArrow': 'Arrow',
  'categoryDefault': 'Default',
  'categoryAnimal': 'Animal',
  'categoryBicycle': 'Bicycle',
  'categoryBoat': 'Boat',
  'categoryBus': 'Bus',
  'categoryCar': 'Car',
  'categoryCrane': 'Crane',
  'categoryHelicopter': 'Helicopter',
  'categoryMotorcycle': 'Motorcycle',
  'categoryOffroad': 'Offroad',
  'categoryPerson': 'Person',
  'categoryPickup': 'Pickup',
  'categoryPlane': 'Plane',
  'categoryShip': 'Ship',
  'categoryTractor': 'Tractor',
  'categoryTrain': 'Train',
  'categoryTram': 'Tram',
  'categoryTrolleybus': 'Trolleybus',
  'categoryTruck': 'Truck',
  'categoryVan': 'Van',
  'categoryDrone': 'Drone',
  'category_20ft_container': '20ft Container',
  'category_40ft_container': '40ft Container',
  'category_airliner': 'Airliner',
  'category_ambulance': 'Ambulance',
  'category_backhoe_loader': 'Backhoe Loader',
  'category_bicycle': 'Bicycle',
  'category_box_trailer': 'Box Trailer',
  'category_bulldozer': 'Bulldozer',
  'category_bus': 'Bus',
  'category_cabriolet': 'Cabriolet',
  'category_camper_van': 'Camper Van',
  'category_car': 'Car',
  'category_car_trailer': 'Car Trailer',
  'category_caravan': 'Caravan',
  'category_concrete_pump': 'Concrete Pump',
  'category_containerized_generator_trailer': 'Containerized Generator Trailer',
  'category_cruiser_motorcycle': 'Cruiser Motorcycle',
  'category_excavator': 'Excavator',
  'category_executive_car': 'Executive Car',
  'category_farm_tractor': 'Farm Tractor',
  'category_fire_truck': 'Fire Truck',
  'category_flatbed_trailer_bulkhead': 'Flatbed Trailer Bulkhead',
  'category_forklift_truck': 'Forklift Truck',
  'category_fuel_tank_truck': 'Fuel Tank Truck',
  'category_gully_emptier': 'Gully Emptier',
  'category_hatchback': 'Hatchback',
  'category_haul_truck': 'Haul Truck',
  'category_helicopter': 'Helicopter',
  'category_luxury_car': 'Luxury Car',
  'category_mixer_truck': 'Mixer Truck',
  'category_motorcycle': 'Motorcycle',
  'category_pedicab': 'Pedicab',
  'category_pickup': 'Pickup',
  'category_police': 'Police',
  'category_recovery_truck': 'Recovery Truck',
  'category_reefer_trailer': 'Reefer Trailer',
  'category_roadside_assistance_car': 'Roadside Assistance Car',
  'category_van': 'Van',
  'category_sewer_cleaning_truck': 'Sewer Cleaning Truck',
  'category_skip': 'Skip',
  'category_steamroller': 'Steamroller',
  'category_swap_tank_container': 'Swap Tank Container',
  'category_tanker_trailer': 'Tanker Trailer',
  'category_taxi': 'Taxi',
  'category_tow_rig': 'Tow Rig',
  'category_tow_truck': 'Tow Truck',
  'category_tractor_flatbed_trailer': 'Tractor Flatbed Trailer',
  'category_tractor_trailer': 'Tractor-trailer',
  'category_tractor_unit': 'Tractor Unit',
  'category_truck': 'Truck',
  'category_ultra_silent_generator_trailer': 'Ultra-silent Generator Trailer',
  'category_waste_tanker_trailer': 'Waste Tanker Trailer',
  'category_water_tank_truck': 'Water Tank Truck',
  'category_default': 'Default',
  'category_drone': 'Drone',
  'label': 'Label',
  'labels': 'Labels',
  'error_this_field': 'This field',
  'error_required_field': 'is required!',
  'error_invalid_type': 'Invalid data for type',
  'sharedInvalidNumber': 'Invalid number',
  'sharedDateInvalid': 'Invalid date',
  'sharedMinZero': 'must be greater than or equal to 0',

  'summaries': 'Summaries',
  'selectDevice': 'Select device',
  'eventHistory': 'Event History',
  'routeHistory': 'Route History',
  'stopHistory': 'Stop History',
  'tripHistory': 'Trip History',
  'journeyHistory': 'Journey History',
  'journeyLoadingRoute': 'Loading route...',
  'journeyTypeMovement': 'Movement',
  'journeyTypeStopped': 'Stopped',
  'journeyTripCount': 'Trips',
  'journeyStopCount': 'Stops',
  'journeyColStatus': 'Status',
  'journeyColStart': 'Start',
  'journeyColEnd': 'End',
  'journeyColDuration': 'Duration',
  'journeyColEngine': 'Engine On',
  'journeyColDriver': 'Driver',
  'journeyColEvents': 'Events',
  'journeyColDistance': 'Dist. ({unit})',
  'journeyColFuel': 'Fuel ({unit})',
  'journeyColStartLoc': 'Start Loc.',
  'journeyColEndLoc': 'End Loc.',

  'typeToSearch': 'Type to search',
  'nothingFound': 'Nothing found!',

  'registeredDevices': 'Registered Devices',
  'devicesConnectionStatus': 'Devices Connection Status',
  'lastCommunicationTime': 'Last communication time',
  'connectionStatusByCategory': 'Connection status by category',
  'openCasualties': 'Open incidents',

  'updatedAtFormat': '[Updated at] MM/DD/YYYY HH:mm',

  'upToThirtyMin': 'Up to 30 min',
  'upToFourHours': 'Up to 4h',
  'upToTwentyFourHours': 'Up to 24h',
  'moreThanTwentyFourHours': 'More than 24h',
  'never': 'Never',
  'upToFortyEightHours': 'Up to 48h',
  'upToSeventyTwoHours': 'Up to 72h',
  'moreThanSeventyTwoHours': 'More than 72h',

  'legendDeviceActive': 'Active',
  'legendDeviceInactive': 'Inactive',
  'legendDeviceOn': 'On',

  'error_unknown': 'Unknown error.',

  // react-dropzone
  [ErrorCode.FileInvalidType]: 'Only {allowed_ext} extensions are allowed.',
  [ErrorCode.FileTooLarge]: 'File is too big, the maximum allowed size is {max_allowed_size}.',
  [ErrorCode.FileTooSmall]: 'File is too small, the minimum allowed size is {min_allowed_size}.',
  [ErrorCode.TooManyFiles]: 'The number os files must be less than or equal to {max_allowed_files}.',
  'companyLabel': 'Subdomain',
  'companyCustomDomain': 'Custom domain',
  'companyHideLoginFooter': 'Hide login footer',
  'companyLogo': 'Logo',
  'companyAndroidAppUrl': 'Android app URL',
  'companyIOSAppUrl': 'iOS app URL',
  'companyTheme': 'Color',
  'companyCustomerAreaLink': 'Customer area link',
  'companyCustomerAreaContact': 'Customer area contact',
  'companyAssistanceService': 'Assistance service',
  'companyMonitoringCenterService': 'Monitoring center service',
  'companyMonitoringCenterContact': 'Monitoring center contact',
  'companyComplete': 'Complete',
  'companyMissing': 'Missing',
  'companyNothingToRemove': 'This company has no configuration to remove yet.',
  'deviceRemoveConfirm': 'You are removing device <strong><field>name</field></strong>! <br/>Are you sure?',
  'savedCommandRemoveConfirm': 'You are removing command <strong><field>description</field></strong>! <br/>Are you sure?',
  'commandBatchSentSuccess': 'Commands sent for execution successfully!',
  'commandBatchCheckAndRetry': 'Please check the fields and try again.',
  'commandBatchChooseDevices': 'Choose device(s)',
  'commandBatchChooseGroups': 'Choose group(s)',
  'commandBatchChooseCommand': 'Choose command',
  'commandBatchExecute': 'Execute',
  'loginAppStoreAlt': 'Available on the App Store',
  'loginGooglePlayAlt': 'Available on Google Play',
  'loginVersion': 'Version 2.0',
  'userRemoveConfirm': 'You are removing user <strong><field>name</field></strong>! <br/>Are you sure?',
  'customerTypePF': 'Individual',
  'customerTypePJ': 'Company',
  'sharedAddressNumber': 'Number',
  'personalDeviceLastUpdate': 'Last update',
  'personalShowAllDevices': 'Show all devices',
  'personalDeviceInfo': 'Device Information',
  'userPaymentHolder': 'Holder',
  'userPaymentDependent': 'Dependent',
  'customerRemoveConfirm': 'You are removing customer <strong><field>name</field></strong>! <br/>Are you sure?',
  'geofenceRemoveConfirm': 'You are removing geofence <strong><field>name</field></strong>! <br/>Are you sure?',
  'groupRemoveConfirm': 'You are removing group <strong><field>name</field></strong>! <br/>Are you sure?',
  'driverRemoveConfirm': 'You are removing driver <strong><field>name</field></strong>! <br/>Are you sure?',
  'customerRegistrationSection': 'Registration Status',
  'geofencePolygon': 'Polygon',
  'maintenanceRemoveConfirm': 'You are removing the configuration <strong><field>name</field></strong>! <br/>Are you sure?',
  'notificationRemoveConfirm': 'You are removing the notification <strong><field>title</field></strong>! <br/>Are you sure?',
  'calendarRemoveConfirm': 'You are removing the calendar <strong><field>name</field></strong>! <br/>Are you sure?',
  'adminChartLastCommunication': 'Last Communication',
  'adminChartConnectionStatus': 'Connection Status',
  'adminChartDeviceConnection': 'Device Connection',
  'adminChartChooseType': 'Choose a type',
  'adminChartChooseStatus': 'Choose a status',
  'adminChartDeviceIncidents': 'Device Incidents',
  'adminChartFilterDevices': 'Filter by devices',
  'adminChartServerDate': 'Server date',
  'adminChartDeviceDate': 'Device date',
  'adminChartGpsDate': 'GPS date',
  'adminEventsFilter': 'Filter Events',
  'unitNauticalMiles': 'Nautical Miles',
  'unitImpGallon': 'Imp. Gallon',
  'unitUsGallon': 'U.S. Gallon',

  // Date/time format strings passed directly to moment().format()
  'dateTimeLongFormat': 'MM/DD/YYYY [-] HH:mm:ss',
  'shortDateFormat': 'MM/DD/YY',
  'dateFormat': 'MM/DD/YYYY',
  'sinisterOpeningDateFormat': 'MM/DD/YYYY [-] HH:mm',
  // Billing block (delinquency)
  'billingBlockTab': 'Suspension and blocking',
  'billingBlockSubtabSettings': 'Settings',
  'billingBlockSubtabBlocks': 'Blocked',
  'billingBlockSubtabExemptions': 'Blocking exemptions',
  'billingBlockSubtabReport': 'Blocking report',
  'billingBlockRefresh': 'Refresh',
  'billingBlockRetry': 'Try again',
  'billingBlockCancel': 'Cancel',
  'billingBlockLoading': 'Loading…',
  'billingBlockInactiveCentral': 'Your monitoring center has no access to this area. Contact Azul support.',
  'billingBlockDiscardTitle': 'Discard changes?',
  'billingBlockDiscardChanges': 'There are unsaved changes in the settings. If you continue, they will be lost.',
  'billingBlockDiscardConfirm': 'Discard changes',
  'billingBlockErrorAlreadyReleased': 'This device block was already released. The list was refreshed.',
  'billingBlockErrorCentralSuspended': 'The monitoring center is suspended: devices cannot be released and device blocking cannot be turned off. Contact Azul support.',
  'billingBlockErrorAlreadyExemptCustomer': 'This customer is already exempt from device blocking. The exemption list was refreshed.',
  'billingBlockErrorAlreadyExemptDevice': 'This device is already exempt from device blocking. The exemption list was refreshed.',
  'billingBlockErrorOtherCentral': 'This customer or device does not belong to your monitoring center.',
  'billingBlockErrorNotFound': 'The item was not found and may have been removed. The list was refreshed.',
  'billingBlockErrorForbidden': 'Your user is not allowed to change this data.',
  'billingBlockErrorInvalid': 'Check the data you entered and try again.',
  'billingBlockErrorConflict': 'The data changed while the screen was open. The list was refreshed.',
  'billingBlockErrorUnexpected': 'The action could not be completed. Try again in a few moments.',
  'billingBlockReleasedNotExempted': 'The device was released, but the exemption was not created. Create it in the Blocking exemptions subtab.',
  'billingBlockStatusActive': 'Blocked',
  'billingBlockStatusReleased': 'Released',
  'billingBlockCommandStatusPending': 'Pending',
  'billingBlockCommandStatusSent': 'Sent',
  'billingBlockCommandStatusConfirmed': 'Confirmed',
  'billingBlockCommandStatusDiscarded': 'Discarded',
  'billingBlockCommandStatusNotSupported': 'Tracker not supported',
  'billingBlockReleaseReasonPayment': 'Payment',
  'billingBlockReleaseReasonCancelled': 'Cancellation',
  'billingBlockReleaseReasonManual': 'Manual release',
  'billingBlockReleaseReasonOptionDisabled': 'Option turned off',
  'billingBlockReleaseReasonCustomerChanged': 'Device changed customer',
  'billingBlockReleaseReasonExemption': 'Exemption',
  'billingBlockReleaseCommandStatusSent': 'Sent',
  'billingBlockReleaseCommandStatusConfirmed': 'Confirmed',
  'billingBlockReleaseCommandStatusNoConfirmation': 'No confirmation',
  'billingBlockDispatchTypeBlockCommand': 'Block',
  'billingBlockDispatchTypeReleaseCommand': 'Release',
  'billingBlockDispatchResultSent': 'Sent',
  'billingBlockDispatchResultConfirmed': 'Confirmed',
  'billingBlockDispatchResultUnconfirmed': 'Not confirmed',
  'billingBlockDispatchResultNoConfirmation': 'No confirmation',
  'billingBlockDispatchResultPending': 'Pending',
  'billingBlockDispatchResultDiscarded': 'Discarded',
  'billingBlockDispatchResultNotSupported': 'Tracker not supported',
  'billingBlockDispatchResultFailed': 'Failed',
  'billingBlockRunStatusRunning': 'Running',
  'billingBlockRunStatusCompleted': 'Completed',
  'billingBlockRunStatusFailed': 'Failed',
  'billingBlockRunStatusMissed': 'Did not run',
  'billingBlockSettingsTitle': 'Customer suspension and device blocking',
  'billingBlockGraceDays': 'Grace period (days)',
  'billingBlockGraceDaysDefault': 'default: {days} days',
  'billingBlockGraceDaysHelp': 'The grace period applies to the suspension of access for customers and their users and to device blocking. Changing it does not review blocks already applied.',
  'billingBlockGraceDaysInvalid': 'Enter a whole number from 0 to 60, or leave it empty to use the default.',
  'billingBlockBlockDevices': 'Block devices of delinquent customers',
  'billingBlockSave': 'Save',
  'billingBlockSettingsSaved': 'Settings saved.',
  'billingBlockEnableTitle': 'Turn on device blocking?',
  'billingBlockEnableBody': 'Starting with the next daily routine, devices of customers with a charge overdue for more than {days} days receive the block command when they are stopped.',
  'billingBlockEnableAccept': 'I have read and accept the responsibility term.',
  'billingBlockEnableConfirm': 'Turn on device blocking',
  'billingBlockResponsibilityTerm': 'By turning on device blocking, the monitoring center declares that:\n1. It has a contract with each customer that authorizes, expressly and prominently, sending the block command to the device in case of delinquency, and it informed the customer of this consequence before contracting (Consumer Protection Code, arts. 6, III, 46 and 54, § 4). Without this authorization, blocking may constitute taking the law into one\'s own hands (Penal Code, art. 345).\n2. It notifies the customer of the overdue charge and of the date from which the device may be blocked, before the grace period ends.\n3. It does not use blocking to expose the customer to ridicule, embarrassment or threat, nor to interfere with their work, rest or leisure beyond what the contract provides (Consumer Protection Code, arts. 42 and 71).\n4. It exempts customers and devices whose blocking could endanger the life, health or safety of people, such as those installed in ambulances and rescue units (Consumer Protection Code, art. 6, I). The command is only sent when the device is stopped, which does not remove this risk.\n5. It releases the device when the charge is paid, cancelled or renegotiated, and follows up on releases without confirmation in the Blocking report (Consumer Protection Code, art. 51, XVIII).\n6. It keeps the charge data in the Asaas integration correct and is liable for damages caused by an undue block (Civil Code, arts. 186, 187 and 927).\n7. It uses the location and status of the devices only to perform the contract with the customer and to protect credit (General Data Protection Law, art. 7, V and X).',
  'billingBlockDisableTitle': 'Turn off device blocking?',
  'billingBlockDisableBody': 'All devices of your customers blocked for delinquency will be released now. The suspension of customer access does not change.',
  'billingBlockDisableConfirm': 'Turn off device blocking',
  'billingBlockColumnCustomer': 'Customer',
  'billingBlockColumnDevice': 'Device',
  'billingBlockColumnChargeValue': 'Amount',
  'billingBlockColumnChargeDueDate': 'Due date',
  'billingBlockColumnStatus': 'Status',
  'billingBlockColumnCommandStatus': 'Command',
  'billingBlockColumnBlockedAt': 'Blocked at',
  'billingBlockColumnReleaseReason': 'Release reason',
  'billingBlockColumnActions': 'Actions',
  'billingBlockDetails': 'Details',
  'billingBlockDetailsTitle': 'Block of device {device}',
  'billingBlockClose': 'Close',
  'billingBlockDetailCommandSentAt': 'Command sent at',
  'billingBlockDetailReleasedAt': 'Released at',
  'billingBlockDetailReleaseNote': 'Note',
  'billingBlockDetailReleaseCommandStatus': 'Release command',
  'billingBlockFilterStatus': 'Status',
  'billingBlockFilterActive': 'Blocked',
  'billingBlockFilterReleased': 'Released',
  'billingBlockFilterAll': 'All',
  'billingBlockClearFilters': 'Clear filter',
  'billingBlockSearchPlaceholder': 'Type to search',
  'billingBlockSearchNoResults': 'No results',
  'billingBlockSearchClear': 'Clear {field}',
  'billingBlockRelease': 'Release',
  'billingBlockReleaseTitle': 'Release device',
  'billingBlockReleaseBody': 'Device {device} receives the release command. The release applies only to this charge: if another charge becomes overdue, it is blocked again.',
  'billingBlockReleaseNote': 'Release reason',
  'billingBlockReleaseNoteRequired': 'Enter the release reason.',
  'billingBlockReleased': 'Device released.',
  'billingBlockReleaseAndExempt': 'Release and exempt',
  'billingBlockReleaseAndExemptBody': 'Device {device} is released and then {target} becomes exempt from new device blocks.',
  'billingBlockExemptTargetDevice': 'the device',
  'billingBlockExemptTargetCustomer': 'the customer',
  'billingBlockExemptTargetLabel': 'What to exempt',
  'billingBlockExemptTargetDeviceOption': 'This device only',
  'billingBlockExemptTargetDeviceHelp': 'Releases {device} and prevents new blocks on it.',
  'billingBlockExemptTargetCustomerOption': 'All devices of the customer',
  'billingBlockExemptTargetCustomerHelp': 'Releases {count, plural, one {# blocked device} other {# blocked devices}} of {customer} and prevents new blocks on any of their devices.',
  'billingBlockExemptTargetCustomerHelpPending': 'Releases the blocked devices of {customer} and prevents new blocks on any of their devices.',
  'billingBlockReleaseAllPartial': '{released} of {total} devices were released. The customer exemption was not created because a device was not released. Try again.',
  'billingBlockReleasedAndExempted': 'Device released and exemption created.',
  'billingBlockEmptyActive': 'No device is blocked right now.',
  'billingBlockShowReleased': 'Show released',
  'billingBlockEmptyBlocks': 'No device block has been recorded.',
  'billingBlockEmptyFiltered': 'No block matches the chosen filter.',
  'billingBlockNewExemption': 'New exemption',
  'billingBlockExemptionKind': 'Exempt',
  'billingBlockKindCustomer': 'Customer',
  'billingBlockKindDevice': 'Device',
  'billingBlockExemptionNote': 'Note (optional)',
  'billingBlockExemptionWarning': 'The exemption prevents new device blocks, but does not unlock a device that is already blocked. To unlock it, release the block before exempting. The exemption applies only to device blocking.',
  'billingBlockExemptionCustomerExempt': 'Customer {customer} is already exempt. The device exemption remains in effect even if the customer exemption is undone.',
  'billingBlockExemptionTargetRequired': 'Choose the customer or the device.',
  'billingBlockExempt': 'Exempt',
  'billingBlockExemptionCreated': 'Exemption created.',
  'billingBlockColumnTarget': 'Customer or device',
  'billingBlockColumnKind': 'Type',
  'billingBlockColumnNote': 'Note',
  'billingBlockColumnCreatedAt': 'Created at',
  'billingBlockRemoveExemption': 'Undo exemption',
  'billingBlockRemoveExemptionTitle': 'Undo exemption?',
  'billingBlockRemoveExemptionBodyCustomer': 'The customer\'s devices can be blocked again starting with the next daily routine.',
  'billingBlockRemoveExemptionBodyDevice': 'The device can be blocked again starting with the next daily routine.',
  'billingBlockExemptionRemoved': 'Exemption undone.',
  'billingBlockEmptyExemptions': 'No customer or device is exempt from blocking.',
  'billingBlockPeriodFrom': 'From',
  'billingBlockPeriodTo': 'To',
  'billingBlockApplyPeriod': 'Apply',
  'billingBlockPeriodRequired': 'Enter both dates.',
  'billingBlockPeriodInverted': 'The end date must be on or after the start date.',
  'billingBlockPeriodTooLong': 'The period can be at most 30 days long.',
  'billingBlockColumnStartedAt': 'Start',
  'billingBlockColumnFinishedAt': 'End',
  'billingBlockColumnDispatchCount': 'Dispatches',
  'billingBlockOpenRun': 'View dispatches',
  'billingBlockBackToRuns': 'Back to runs',
  'billingBlockRunTitle': 'Dispatches of the run on {date}',
  'billingBlockColumnCharge': 'Charge',
  'billingBlockColumnType': 'Type',
  'billingBlockColumnResult': 'Result',
  'billingBlockColumnTime': 'Time',
  'billingBlockColumnDetail': 'Detail',
  'billingBlockEmptyRuns': 'No routine run in this period.',
  'billingBlockEmptyRunsAtAll': 'The routine has not run yet.',
  'billingBlockResetPeriod': 'Show the day of the latest run',
  'billingBlockEmptyDispatches': 'This run had no dispatches to your customers\' devices.',
};
